import { growthBook } from "@/helpers/growthbook";

/**
 * Hook to determine which cart redesign variant the user is assigned to.
 * Control (0) = current cart design.
 * Variation (1) = redesigned cart from Figma.
 */
export const useCartRedesignVariant = (): { isVariation: boolean } => {
  const variant = growthBook.getFeatureValue("cart-redesign", 0);
  return { isVariation: variant === 1 };
};
